import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';
import { WorksheetAction } from '@autoinformer/services/formatter/WorksheetAction';

class WorksheetsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  createInit(id) {
    return this.http.post(`/${id}/scheme/init`);
  }

  getScheme(campaign_id) {
    
    return this.http
      .get(`/${campaign_id}/schema`)
      .then((response) => {
        return WorksheetAction.formatItemFromBackend(response);
      })
      .then(({ items }) => {
        return { id: campaign_id, items };
      });
    // .then((item) => WorksheetAction.formatItemFromBackend(item))
    // .then(({ items }) => ({ id, items }));
  }

  deleteScheme(id) {
    return this.http.delete(`${id}/schema/drop`);
  }

  createItem(worksheet_id, params) {
    return this.http
      .post(`/${worksheet_id}/actions`, params)
      .then((item) => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }

  updateItem(id, action_id, params) {
    return this.http
      .put(`${id}/actions/${action_id}`, params)
      .then((item) => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }

  removeItem(id, action_id) {
    return this.http.delete(`${id}/actions/${action_id}`);
  }
}

export const WorksheetsService = new WorksheetsServiceClass({
  api_version: 2,
  resource: 'informer/campaigns'
});
